<div class="sidenav-container px-20 bg-[#F2F3F5] py-40">
    <h2 class="pb-40 my-0 text-2xl font-medium text-gray-700 pointer" (click)="onRootClick()">
        {{ 'NAV.CATALOG.TITLE' | translate }}
    </h2>

    <div class="sidenav">
        <ul class="category-list">
            <ng-container *ngFor="let category of categories; trackBy: trackById">
                <li>
                    <div
                        class="dropdown-container py-4 px-8"
                        [ngClass]="{
                            selected: category.open,
                            'bg-[#EDEEF0]': shouldHaveBg(category)
                        }"
                    >
                        <div
                            class="category-item"
                            [ngClass]="{
                                'bg-[#E8E9EB] font-medium': category.id === selectedCategoryId,
                            }"
                        >
                            <mat-icon class="icon-18 mx-8" *ngIf="category.hasPublishedSubCategories" (click)="toggleCategory(category)">
                                {{ category.open ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                            </mat-icon>

                            <mat-icon *ngIf="!category.hasPublishedSubCategories" class="circle mx-8">circle</mat-icon>

                            <a class="text-truncate" (click)="openCategory(category)" [tooltipIfTruncated]="category.name">
                                {{ category.name }}
                            </a>
                        </div>

                        <ul *ngIf="category.open && category.children?.length" class="course-structure-categories pl-4">
                            <ng-container *ngTemplateOutlet="listItem; context: { $implicit: category.children }"></ng-container>
                        </ul>
                    </div>
                </li>
            </ng-container>
        </ul>

        <ng-template #listItem let-children>
            <li *ngFor="let sub of children">
                <div
                    class="subcategory-item pl-24"
                    [ngClass]="{
                        'bg-[#E8E9EB] font-medium': sub.id === selectedCategoryId,
                        'bg-[#EDEEF0]': isParent(sub)
                    }"
                >
                    <mat-icon class="icon-18 mx-8" (click)="toggleCategory(sub)" *ngIf="sub.hasPublishedSubCategories">
                        {{ sub.open ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                    </mat-icon>

                    <mat-icon *ngIf="!sub.hasPublishedSubCategories" class="circle mx-8">circle</mat-icon>

                    <a class="text-truncate" (click)="openCategory(sub)" [tooltipIfTruncated]="sub.name">
                        {{ sub.name }}
                    </a>
                </div>

                <ul *ngIf="sub.open && sub.children?.length" class="course-structure-category-nested pl-16">
                    <ng-container *ngTemplateOutlet="listItem; context: { $implicit: sub.children }"></ng-container>
                </ul>
            </li>
        </ng-template>
    </div>
</div>
